// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3i2-A","validationTips":"StatementDescriptor_validationTips__32vk4"};